var getDisplay = function getDisplay() {
  return function (_ref) {
    var block = _ref.block;
    return block ? "block" : "inline-block";
  };
};

export default getDisplay;